/**
 */
export enum ResizerMode {
  /**
   * No resizing applied.
   */
  None,
  /**
   * Fills the container without limits on aspect ratio.
   */
  Fill,
  /**
   * Fills the container while locking to the aspect ratio
   * calculated from width and height. Is flexible between a range
   * determined by the "maxWidth" property.
   */
  Aspect
}
